import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchServices } from '../rtk/slices/services-slice'
import { fetchColor } from '../rtk/slices/color-slice'

function Products () {
    const color = useSelector((state) => state.color.color);
    const dispatch = useDispatch();
    const services = useSelector((state) => state.services.services);
    const [servicesSearch, setServicesSearch] = useState(services);

    const filterService = (searchKeyword) => {
        console.log(searchKeyword);
        const updateData = services.filter((service) => service.keyword.includes(searchKeyword));
        setServicesSearch(updateData)
    }

    if (color.length > 0) {
        let inputString = color[0].color;
        let filteredValue = inputString.replace(/[^0-9,]/g, '');

        // تعيين قيمة المتغير --main-color في :root
        const root = document.documentElement;
        root.style.setProperty("--main-color", `${filteredValue}`);
    }

    useEffect(() => {
        // fetch color
        dispatch(fetchColor());

        // fetch services
        dispatch(fetchServices());

    }, [])

    return (
        <section className='projects services' id='projects'>
            <div className="container">
                <h2 className="title">
                    <span>Products</span>
                    <p>Products</p>
                </h2>

                <form style={{ marginTop: "3rem" }}>
                    <div className="input-box">
                        <div className="input-field">
                            <input className='myInput' name='name' type="text" onChange={(e) => filterService(e.target.value.toLowerCase())} placeholder='Product Name?' required />
                            <div className="icon"><i class="fa fa-search"></i></div>
                        </div>
                    </div>
                    {/* <div class="btn-box btns"><button class="button type1"><span class="btn-txt"><a>بحث</a></span></button></div> */}
                </form>

                <div className="cards">

                    {servicesSearch.length < 1 ?
                        services.map((service) => {
                            return (
                                <div className="card">
                                    <h3><img className="img-swiper" src={`${process.env.REACT_APP_PROJECTS_API}assest/imgs/${service.img_service}`} alt={`${service.img_service}`} /></h3>
                                    <p style={{ textTransform: "capitalize" }}>{service.keyword}</p>
                                    <Link to={`/products/product/${service.keyword}`}></Link>
                                </div>
                            )
                        })
                        :
                        servicesSearch.map((service) => {
                            return (
                                <div className="card">
                                    <h3><img className="img-swiper" src={`${process.env.REACT_APP_PROJECTS_API}assest/imgs/${service.img_service}`} alt={`${service.img_service}`} /></h3>
                                    <p style={{ textTransform: "capitalize" }}>{service.keyword}</p>
                                    <Link to={`/products/product/${service.keyword}`}></Link>
                                </div>
                            )
                        })
                    }

                </div>

                <Link className='exit' to={`/`}>
                    <div class="menu active">
                        <span class="span1"></span>
                        <span class="span2"></span>
                        <span class="span3"></span>
                    </div>
                </Link>
            </div>
        </section>
    )
}

export default Products
